<template>
  <div style="margin: 0 20px">
    <div style="height: 20px;"></div>
    <div style="height: 40px;font-size: 18px;text-align: center">
      <span>是否存在以下服务对象</span>
    </div>
    <div style="height: 350px">
      <el-table
        :data="showTable"
        border
        height="100%"
        style="width: 100%"
        highlight-current-row
        ref="tableData"
        @row-click="singleElection">
        <el-table-column label="" width="65" align="center">
          <template slot-scope="scope">
            <el-radio class="radio" v-model="templateSelection" :label="scope.$index">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="60"
          align="center">
        </el-table-column>
        <el-table-column
          label="性别"
          width="50"
          align="center">
          <template slot-scope="scope">
            <span>{{getSex(scope.row.sex)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="birthday"
          label="出生日期"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="电话号码"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column
          prop="h_address"
          label="家庭地址"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column
          prop="timelist"
          label="接听电话时间段"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column
          prop="circumstances"
          label="特殊情况"
          min-width="90"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 20px">
      <el-row style="margin: 0 100px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeOpen()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="selectRow()">
            <span>下一步</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 20px;"></div>
  </div>
</template>

<script>
export default {
  name: 'searchPersonList',
  model: {
    prop: 'searchList',
    event: 'change'
  },
  props: {
    personListObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      row: '',
      templateSelection: '',
      templateRadio: '',
      showTable: []
    }
  },
  created () {
    this.showTable = this.personListObj.searchPersons
  },
  methods: {
    singleElection (row) {
      this.row = row
      this.templateSelection = this.showTable.indexOf(row)
      this.templateRadio = row.id
    },
    selectRow () {
      this.$emit('getFatherSelect', this.row)
    },
    closeOpen () {
      this.$emit('change', false)
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/components/searchPersonList.vue